/**
 * Получаем заведения с данными для карты 2ГИС
 * @param data Массив объектов
 * @param elementId ID элемента в DOM-дереве (куда будет интегрироваться карта)
 * @param cityCenterCoords Координаты центра карты
 * @param cityName Url-имя города
 */
window.get2GISMap = (data = {}, elementId = 'map', cityCenterCoords = [], cityName) => {
    let saunasData = Array.isArray(data) && data.length ? data : [data];
    let host = `${window.location.protocol}//${window.location.host}`;

    cityCenterCoords = cityCenterCoords.length === 0 ? [55.75396, 37.620393] :
        typeof cityCenterCoords === 'string' ? cityCenterCoords.split(',').reverse() :
            cityCenterCoords;

    if (saunasData.length === 1 && saunasData[0].smapc) {
        cityCenterCoords = saunasData[0].smapc.split(',').reverse();
    }

    const regexExp = `/^(-?d+(.d+)?),s*(-?d+(.d+)?)$/`;
    let saunas = saunasData.map(item => {
        // Если у элемента нет свойства smapc или оно пустое, пропускаем его
        if (!item.smapc) return false;

        let saunaCoords = item.smapc.split(',').map(Number); // Преобразуем координаты в числа

        // Проверяем, что координаты — это два валидные числа
        if (saunaCoords.length !== 2 || !saunaCoords.every(coord => !isNaN(coord))) return false;

        // Возвращаем объект Feature для GeoJSON
        return {
            type: "Feature",
            properties: {
                title: item.title,
                address: item.address,
                prices: item.min_price !== item.max_price ? `от ${item.min_price} до ${item.max_price} р/час` : `${item.max_price} р/час`,
                url: `${host}/${cityName}/${item.name}`
            },
            geometry: {
                type: 'Point',
                coordinates: saunaCoords
            }
        };
    }).filter(Boolean); // Фильтруем ложные значения

    DG.then(() => {
        const element = document.getElementById(elementId);
        const childElementId = `map--${elementId}`;

        removeAllChildNodes(element);
        element.insertAdjacentHTML('afterbegin', `<div id="${childElementId}" style="width: 100%; height: 100%;"></div>`);

        let map = DG.map(childElementId, {
            center: cityCenterCoords,
            zoom: 13,
            fullscreenControl: false,
        });

        DG.geoJson({type: "FeatureCollection", features: saunas}, {
            onEachFeature: (feature, layer) => {
                let html = `
                    <div class="map2gis">
                        <p class="map2gis__title">${feature.properties.title}</p>
                        <p class="map2gis__item"><span>Адрес:</span> ${feature.properties.address}</p>
                        <p class="map2gis__item"><span>Цена:</span> ${feature.properties.prices}</p>
                        <a href="${feature.properties.url}" class="d-inline-block map2gis__link mt-3" target="_blank">Подробнее</a>
                    </div>
                `;
                layer.bindPopup(html).bindLabel(feature.properties.title);
            }
        }).addTo(map);
    });
};
